<template>
<div class="contents">
  <admin adminType="staff" :id="id" :searchPrm="searchPrm" />
</div>
</template>
<script>
import Admin from '../Admin/AdminWashRequestChange/index.vue'
export default {
  name: 'staff-wash-requests-change',
  props: {
    id: {
      type: [String, Number],
      default: -1
    },
    searchPrm: {
      type: Object,
      'default': () => ({
        staffId: '',
        createdDtFrom: '',
        createdDtTo: '',
        filterWreqCreated: false,
        filterPickedUp: false,
        filterWashed: false,
        filterFolded: false,
        filterDelivered: false,
        userId: '',
        bagSize:'',
      })
    }
  },
  components: {
    Admin
  }
}
</script>
